import { useState } from "react";
import Chart from "react-apexcharts";
import "./DashboardLastData.css";

const DashboardLastData = () => {
  const [options] = useState({
    chart: {
      width: "100%",
      type: "donut",
      events: {
        dataPointMouseEnter: function (event) {
          event.path[0].style.cursor = "pointer";
        },
      },
      offsetX: 50,
      fontFamily: "poppins",
    },
    // labels: [
    //   "Point one",
    //   "Point two",
    //   "Point three",
    //   "Point four",
    //   "Point five",
    //   "Point six",
    // ],
    legend: {
      show: false,
      horizontalAlign: "left",
      position: "right",
      fontFamily: "poppins",
      labels: {
        colors: "#757679",
      },
      markers: {
        radius: 20,
        fillColors: [
          "#816af8",
          "#ffe700",
          "#fd6b3f",
          "#2d98ff",
          "#525d70",
          "#2dd8c5",
        ],
      },
    },
    grid: {
      padding: {
        top: 10,
        right: -10,
        bottom: 20,
        left: 20,
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
        offsetX: 40,
        offsetY: 30,
        customScale: 1,
        dataLabels: {
          offset: 0,
          minAngleToShowLabel: 10,
          //   show: false,
        },

        donut: {
          labels: {
            show: true,
            name: {
              offsetY: 18,
            },
            value: {
              show: true,
              fontSize: "15px",
              fontWeight: 700,
              offsetY: -15,
              formatter: function (val) {
                return val;
              },
            },
            total: {
              showAlways: true,
              fontSize: "10px",
              show: true,
              formatter: function (w) {
                return 12
                // return w.globals.seriesTotals.reduce((a, b) => {
                //   return b === series[series.length - 1] ? `$${a + b}` : a + b;
                // }, 0);
              },
            },
          },
        },
      },
    },
    stroke: {
      width: 0,
    },
    colors: ["#816af8", "#ffe700", "#fd6b3f", "#2d98ff", "#525d70", "#2dd8c5"],
    dataLabels: {
      enabled: false,
    },

    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: {
            width: "400",
            offsetX: 0,
            height: "220",
          },
          grid: {
            padding: {
              top: 0,
              right: 20,
              bottom: 0,
            },
          },
          legend: {
            position: "bottom",
          },
        },
      },
      {
        breakpoint: 500,
        options: {
          chart: {
            width: 300,
            offsetX: -15,
          },
          grid: {
            padding: {
              top: 0,
              right: 0,
              left: 10,
              bottom: 0,
            },
          },
          legend: {
            position: "bottom",
          },
        },
      },

      {
        breakpoint: 375,
        options: {
          chart: {
            offsetX: -75,
            width: 300,
            height: 200,
          },
          grid: {
            padding: {
              left: 0,
              top: 0,
              bottom: 0,
            },
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });
  const [series] = useState([70, 66, 55, 44, 22, 13]);
  return (
    <div className="dashboardLastData">
      <div className="dashboardLastData__header flex-row">
        <div>
          <h3>Favorite topics</h3>
        </div>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7596 8.37402C11.7596 7.33634 12.6086 6.48734 13.6463 6.48734C14.6839 6.48734 15.5329 7.33634 15.5329 8.37402C15.5329 9.4117 14.6839 10.2607 13.6463 10.2607C12.6086 10.2607 11.7596 9.4117 11.7596 8.37402ZM6.09951 8.37402C6.09951 7.33634 6.94852 6.48734 7.9862 6.48734C9.02387 6.48734 9.87288 7.33634 9.87288 8.37402C9.87288 9.4117 9.02387 10.2607 7.9862 10.2607C6.94852 10.2607 6.09951 9.4117 6.09951 8.37402ZM0.439453 8.37402C0.439453 7.33634 1.28846 6.48734 2.32614 6.48734C3.36382 6.48734 4.21282 7.33634 4.21282 8.37402C4.21282 9.4117 3.36382 10.2607 2.32614 10.2607C1.28846 10.2607 0.439453 9.4117 0.439453 8.37402Z"
            fill="#818E94"
          />
        </svg>
      </div>
      <div className="dashboardLastData__container flex-row">
        <ul className="dashboardLastData__percents">
          <li className="dashboardLastData__percentItem one flex-row ">
            <div className="flex-row">
              <div className="dashboardLastData__percentCircle rounded"></div>
              Science
            </div>
          </li>
          <li className="dashboardLastData__percentItem two flex-row ">
            <div className="flex-row">
              <div className="dashboardLastData__percentCircle rounded"></div>
              Business
            </div>
          </li>
          <li className="dashboardLastData__percentItem three flex-row ">
            <div className="flex-row">
              <div className="dashboardLastData__percentCircle rounded"></div>
              Sports
            </div>
          </li>
          <li className="dashboardLastData__percentItem four flex-row ">
            <div className="flex-row">
              <div className="dashboardLastData__percentCircle rounded"></div>
              Arts
            </div>
          </li>
          <li className="dashboardLastData__percentItem five flex-row ">
            <div className="flex-row">
              <div className="dashboardLastData__percentCircle rounded"></div>
              Sports
            </div>
          </li>
          <li className="dashboardLastData__percentItem six flex-row ">
            <div className="flex-row">
              <div className="dashboardLastData__percentCircle rounded"></div>
              Commerce 
            </div>
          </li>
        </ul>
        <Chart options={options} series={series} type="donut" />
      </div>
    </div>
  );
};

export default DashboardLastData;
